(ns app.domain.group.plan-review-integration-model
  (:require [app.domain.attachment.model :as attachment-model]
            [clojure.string :as str]))

(defmulti ^{:arglists '([workspace])} review-url
  (fn [workspace]
    (-> workspace
        :domain/authority-group
        :group/plan-review-integration-config
        :integration-config/service)))

(defmulti ^{:arglists '([attachment])} single-attachment-review-url
  (fn [attachment]
    (-> attachment
        :entity/parent
        :entity/parent
        :domain/authority-group
        :group/plan-review-integration-config
        :integration-config/service)))

(defmethod review-url :integration-config.service/digeplan [{:workspace/keys [id] :as workspace}]
  (when-let [url (-> workspace
                     :domain/authority-group
                     :group/plan-review-integration-config
                     :integration-config/base-url)]
    (str url
         (when-not (str/ends-with? url "/")
           "/")
         "app/cases/"
         id)))

(defmethod single-attachment-review-url :integration-config.service/digeplan [attachment]
  (str (-> attachment :entity/parent :entity/parent review-url)
       "/"
       (:db/id attachment)
       "-"
       (-> attachment attachment-model/latest-attachment-version :attachment.version/version)))

(def bluebeam-integration-browser-service-url
  "https://app.bluebeam.com")

(def bluebeam-integration-revu-service-url
  "studio://studio.bluebeam.com")

(defn bluebeam-session-url
  "Constructs the web URL for a Bluebeam session editor."
  [session-id]
  (when session-id
    (str bluebeam-integration-browser-service-url
         "/sessions/"
         session-id
         "/editor")))

(defn bluebeam-studio-url
  "Builds a `studio://` URL that opens the Bluebeam Revu app."
  [session-id]
  (when session-id
    (str bluebeam-integration-revu-service-url
         "/"
         session-id)))
